@if (lesson | async; as lesson) {
  <ng-container class="lesson">
    <header class="lesson-header">
      <div>
        <h1>Identification, Strategy and Hypothesis</h1>
        <p>{{lesson.matchAnswerCopy}}</p>
      </div>
    </header>
    <app-problem-multiple-choice-container-orig
      [title]="lesson.matchAnswerPrompt"
      [correctTitle]="lesson.matchAnswerCorrectCopy"
      [incorrectTitle]="lesson.matchAnswerIncorrectCopy"
      (onNext)="handleNext()">
    </app-problem-multiple-choice-container-orig>
  </ng-container>
} @else {
  <app-spinner></app-spinner>
}

